










































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '../../../store.vuex';
import { countries } from '../../Commons/phone-code-countries';
import GDPR from '../../Registration/GDPR.vue';
import PasswordIndicator from './PasswordIndicator.vue';
import ReCaptcha from '../../../components/ReCaptcha/ReCaptcha.vue';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';
import { RecaptchaResponse } from '@/models/referrals/recaptchaResponse';
import sanitizeHtml from 'sanitize-html';

declare var window: any;
@Component({
  components: { GDPR, PasswordIndicator, ReCaptcha},
})
export default class SignupFormV2 extends Vue {
  private showPassword = false;
  private candidatePhone: string = '';
  private countryCode: string = '';

  private isGDPREnabled: boolean = true;
  private noExample: boolean = true;
  private noFlags: boolean = true;
  private isWhatsapp:boolean=false;
  private gdprObj = { marketingEmailFlag: false, tosEmailFlag: false };
  @Prop() register;
  @Prop() wlUser;
  @Prop() errors;
  @Prop() socialRegistration;
  @Prop() isEmailSystemGenerated;
  private defaultEmailValue = '';
  private showPasswordCriteriaText: boolean = false;
  $toastr: any;

  private recaptchaSizeValue: string = vxm.utility.isVisibleReCaptcha
    ? 'normal'
    : 'invisible';

  get passwordAriaLabel() {
    return (vxm.utility.passwordConditions || "").split("and").join(".")
  }

  passwordStatus(value) {
    if (!value) {
      this.errors.password =
        this.$t('password-does-not-satisfy-min-requirement');
    } else {
      this.errors.password = '';
    }
  }

  get isDisabled() {
    if (
      this.wlUser &&
      this.wlUser.email &&
      (this.socialRegistration ? true : this.wlUser.password) &&
      this.wlUser.firstName &&
      this.wlUser.lastName &&
      this.candidatePhone && 
      this.recaptchaValue
    ) {
      if (this.isGDPREnabled && (!this.gdprObj.tosEmailFlag || !this.gdprObj.marketingEmailFlag)) {
        return true;
      } else if (this.isGDPREnabled && (this.gdprObj.tosEmailFlag || this.gdprObj.marketingEmailFlag)) {
        false;
      }
      return false;
    }
    return true;
  }

  removePasswordCriteriaTextSection() {
    this.showPasswordCriteriaText = false;
  }

  togglePasswordCriteriaTextSection() {
    this.showPasswordCriteriaText = true;
  }

  get showWhatsApp(){
    return vxm.configs.whatsappNotificationEnabled
  }

  gdpr(gdprObj: any) {
    this.gdprObj = gdprObj;
    if (this.wlUser && gdprObj) {
      this.wlUser.marketingEmailFlag = gdprObj.marketingEmailFlag;
    }
   this.wlUser.userAgreement = true;

  }

  get UserTOSAgreementText() {
    this.wlUser.userAgreement = true;
    const customTOStext = vxm.configs.getGlobalConfigValue('USER_TOS_AGREEMENT_TEXT');
    if (customTOStext) return customTOStext
      .replace(/{companyName}/g, vxm.utility.companyName)
      .replace(/{termsOfServiceURL}/g, this.termsOfServiceURL)
      .replace(/{privacyPolicyURL}/g, this.privacyPolicyURL);
    return this.$t('signup.terms.services', {
      termsOfServiceURL: this.termsOfServiceURL,
      privacyPolicyURL: this.privacyPolicyURL,
      companyName: this.companyName
    })
  }
  
  get companyName(): String {
    return vxm.utility.companyName;
  }

  setShowPassword() {
    this.showPassword = !this.showPassword;
  }
  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
      );
   if( event.countryCallingCode + ' ' + event.nationalNumber != "+undefined undefined"){
    this.wlUser.phone =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.wlUser.phoneNumberValid = event.isValid;
    }
  }
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }


  setDefaultFontFirstName(){

    setTimeout(() => {
  

   var copiedText =   this.wlUser.firstName 
   var formattedString = copiedText.replace(/[^a-zA-Z0-9\s]/g, '');
    if(formattedString.length!=copiedText.length){
      
      this.wlUser.firstName = null;
 
      this.$toastr(
          'error',
          this.$t('no.special.characters.allowed.firstname'),
        );
  
      return false;
    }
    return true;
  }, 50);
}

  setDefaultFontLastName(){
    setTimeout(() => {

   var copiedText =   this.wlUser.lastName



   var formattedString = copiedText.replace(/[^a-zA-Z0-9\s]/g, '');
    if(formattedString.length != copiedText.length){
      
      this.wlUser.lastName = null;
 
      this.$toastr(
          'error',
          this.$t('no.special.characters.allowed.lastname'),
        );

        return false;
      
    }
    return true
  }, 50);
   

  }
  verifyNames(){
    this.setDefaultFontFirstName();
 this.setDefaultFontLastName();
    }

  isNumber(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
    return true;
  }
  get globalRefCode() {
    const RefCode = vxm.referrals.globalRefCode;
    console.log('RefCode', [RefCode]);
    this.wlUser.referralUrl = RefCode;
    return RefCode;
  }

 
  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  onRecaptchaExpired() {
    vxm.referrals.setRecaptchaResponse(new RecaptchaResponse());
  }

  mounted() {
    vxm.referrals.setRecaptchaResponse(new RecaptchaResponse());
    let userParams = vxm.users.UserParams;
    this.isGDPREnabled = vxm.configs.getGlobalConfigValue('IS_GDPR_ENABLED');
    this.countryCode = vxm.utility.defaultCountry;
    this.wlUser.email = userParams.email;
    this.wlUser.enabled = this.socialRegistration ? true : false; //to force email confirmation using the opt login
        console.log("user paramss....",this.wlUser);
    this.defaultEmailValue = this.wlUser.email;
    let profile  = vxm.users.myUserProfile;
    if(!this.wlUser.email && (profile && profile.email)) {
      this.wlUser.email = profile.email;
    }
    if (userParams.populateSignupPage) {
      this.wlUser.email = userParams.email;
      this.wlUser.firstName = userParams.firstName;
      this.wlUser.lastName = userParams.lastName;
      this.wlUser.referralCode = this.globalRefCode;
      const phoneNum = userParams.phone
        ? parsePhoneNumber(userParams.phone)
        : undefined;

      this.candidatePhone = phoneNum ? phoneNum.nationalNumber : '';
      this.wlUser.phoneNumberValid = isValidPhoneNumber(userParams.phone);

      let dialCode = userParams.phone.substring(
        1,
        userParams.phone.indexOf(' '),
      );
      for (var i = 0; i < countries.length; i++) {
        if (countries[i].dialCode === dialCode) {
          this.countryCode = countries[i].iso2;
        }
      }
    }
    else{
      const phoneNum = this.wlUser.phone
        ? parsePhoneNumber(this.wlUser.phone)
        : undefined;

      this.candidatePhone = phoneNum ? phoneNum.nationalNumber : '';
      this.wlUser.phoneNumberValid = isValidPhoneNumber(userParams.phone);

    }
  }

  @Watch('wlUser')
  setUser(newVal) {
    if (newVal.phone) {
      this.candidatePhone = this.formatPhone(newVal.phone);
      this.wlUser.phoneNumberValid = this.isValidPhone(newVal.phone);
    }
    this.wlUser.enabled = false;
  }

  formatPhone(value): string {
    if (value) {
      const phoneNum = parsePhoneNumber(value);
      return phoneNum.formatNational();
    } else {
      return '';
    }
  }

  isValidPhone(value): boolean {
    return isValidPhoneNumber(value);
  }

  get recaptchaValue(): boolean {
    return this.showRecaptcha ? vxm.referrals.RecaptchaResponse.success : true;
  }

  get showRecaptcha(): boolean {
    return vxm.utility.showSignUpReCaptcha;
  }
}
